import { z } from 'zod';

export const classOverviewSchema = z.object({
  type: z.literal('classOverview'),
  data: z.array(
    z.object({
      student: z.object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
      }),
      totalTimeEngaged: z.number(),
      articlesViewed: z.number(),
      annotationsPerArticle: z.number(),
      videosWatched: z.number(),
      activitiesCompleted: z.number(),
      avgQuizScore: z.number().nullable(),
    })
  ),
});

export type ClassOverviewResponse = z.infer<typeof classOverviewSchema>;
